module.exports = __webpack_public_path__ + "img/sm.2d3943c1.svg";